// Shared scaffold for create/edit dialogs — reset-on-open, error line, footer
// with cancel/submit buttons and a pending spinner.
import { Loader2 } from 'lucide-react';
import type { ReactNode } from 'react';
import { Button } from './button';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from './dialog';

export function FormDialog({
  open,
  onOpenChange,
  onReset,
  title,
  submitLabel,
  pending,
  error,
  onSubmit,
  children,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Called when the dialog (re)opens to initialize form state. */
  onReset: () => void;
  title: string;
  submitLabel: string;
  pending: boolean;
  error: string;
  onSubmit: () => void;
  children: ReactNode;
}) {
  return (
    <Dialog
      open={open}
      onOpenChange={(v) => {
        if (v) onReset();
        onOpenChange(v);
      }}
    >
      <DialogContent className="max-w-lg" onOpenAutoFocus={onReset}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-4">
          {children}
          {error ? <p className="text-xs text-destructive">{error}</p> : null}
        </div>
        <DialogFooter>
          <Button variant="outline" size="sm" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button size="sm" onClick={onSubmit} disabled={pending}>
            {pending ? <Loader2 className="mr-1 h-3 w-3 animate-spin" /> : null}
            {submitLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
